import axios from 'axios'
import qs from 'qs'
import {Message, MessageBox} from 'element-ui';
import {hideLoading} from "../../../common-components/src/components/Loading/loading";

// 创建一个axios实例
const service = axios.create({
    baseURL: "/",
    // 请求超时时间
    timeout: 10000,
    // 允许携带cookie
    withCredentials: true,
})
service.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
service.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
// 添加请求拦截器
service.interceptors.request.use(config => {
      if (config.headers['Content-Type'] == 'application/x-www-form-urlencoded'){
          config.data = qs.stringify(config.data)
      }
      if(localStorage.getItem('rs_t')){
          config.headers.authorization = localStorage.getItem('rs_t');
      }
      //请求缓存处理,
      if(config.url.indexOf('?')>-1){
        config.url = config.url + '&timestamp='+new Date().getTime();
      }else{
        config.url = config.url + '?timestamp='+new Date().getTime();
      }
      return config
  },
  err => {
    console.log(err)
  }
)

//响应拦截
service.interceptors.response.use(
  response => {
      if (!response.data.success && response.data.errorCode == -503){
          sessionStorage.setItem('loginError', 1);
          let fromPc = sessionStorage.getItem('fromPc');
          if ((fromPc && fromPc == 1) || (response.data.data && response.data.data.clientType == "PC")){
              hideLoading();
              MessageBox.alert('您的帐号已在其它设备登录或登录已过期，请重新登录授课端', '', {
                  showConfirmButton: false,
                  showClose: false,
              });
              return;
          }
          if (response.config.url.startsWith("/resapi/tw/user/loginCheck")){
              window.location.replace(localStorage.getItem('resourceLoginUrl'));
              return response.data
          }else {
              hideLoading();
              MessageBox.alert('您的帐号已在其它设备登录或登录已过期，请重新登录系统', '', {
                  confirmButtonText: '确定'
              }).then(() => {
                  window.location.replace(localStorage.getItem('resourceLoginUrl'));
              }).catch(() => {
                  window.location.replace(localStorage.getItem('resourceLoginUrl'));
              });
              return;
          }
      }
      sessionStorage.setItem('loginError', 0);
    return response.data
  },
  err => {
      console.log(err);
      Message.error("网络异常，请检查网络后再试");
  }
)

export default service
